module.exports = __webpack_public_path__ + "static/img/background2.b2fd95f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background2.png
// module id = 697
// module chunks = 1